export const record_limits = [10,20,30] //used to set the limits from one signle place
export const default_limit = 10;